import { ToastProviderProps } from '@chakra-ui/react';

export const toastOptions: ToastProviderProps = {
  defaultOptions: {
    position: 'top',
    duration: 6000,
    isClosable: true,
  },
};
